import {isFeatureEnabled} from '@github-ui/feature-flags'

export interface RelayReadinessReceipt {
  readonly observedAtMs: number
  readonly monotonicMs: number
  readonly source: 'snapshot' | 'action' | 'cache'
}

export interface RelayReadinessEvidence {
  readonly chat?: RelayReadinessReceipt
  readonly session?: RelayReadinessReceipt
  readonly role?: RelayReadinessReceipt
  readonly adopted?: RelayReadinessReceipt
}

export function captureRelayReadiness(source: RelayReadinessReceipt['source']): RelayReadinessReceipt | undefined {
  try {
    if (!isFeatureEnabled('copilot_ui_readiness_telemetry')) return undefined
    return {observedAtMs: Date.now(), monotonicMs: performance.now(), source}
  } catch {
    // This observer must never interrupt snapshot application or connection setup.
    // eslint-disable-next-line no-console
    console.error('[ahp-relay] Unable to capture UI readiness receipt')
    return undefined
  }
}
